import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVideo2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="video-2, camera, movie, play"><path d="M13.75 4.5C15.8211 4.5 17.5 6.17893 17.5 8.25V15.75C17.5 17.8211 15.8211 19.5 13.75 19.5H5.75C3.67893 19.5 2 17.8211 2 15.75V8.25C2 6.17893 3.67893 4.5 5.75 4.5H13.75Z" fill="currentColor"/><path d="M20.4434 7.21484C21.4284 6.82118 22.4998 7.54658 22.5 8.60742V15.3926C22.4998 16.4534 21.4284 17.1788 20.4434 16.7852L18.5 16.0078V7.99219L20.4434 7.21484Z" fill="currentColor"/></CentralIconBase>;
};

export default IconVideo2;
